module.exports = __webpack_public_path__ + "static/img/m_coupon_bg2.3b544f3f.png";